define("shared/components/shared/media/filter/filter-profile", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _service, _utils, _component2, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper qa--mediaLib_profile_drpdwn">
    <PowerSelect
      @onChange={{action @toggleSocialProfile}}
      @options={{this.socialProfileOptions}}
      @renderInPlace={{true}}
      @searchEnabled={{false}}
      @selected={{this.selectedProfile}}
      data-test-id="filter-profile-select"
      as |profile|
    >
      <span class="qa--mediaLib_profileSelect" {{did-update this.buildSocialProfileOptions}} {{perfect-scroll}}>
        <i class="{{profile.profileIconColorClass}} u--m__r__xs"></i>
        <span data-test-id="social-profile-option">
          {{profile.displayNickname}}
        </span>
      </span>
    </PowerSelect>
  </div>
  */
  {
    "id": "MsP0d8JA",
    "block": "[[[10,0],[14,0,\"o--formWrapper qa--mediaLib_profile_drpdwn\"],[12],[1,\"\\n  \"],[8,[39,0],[[24,\"data-test-id\",\"filter-profile-select\"]],[[\"@onChange\",\"@options\",\"@renderInPlace\",\"@searchEnabled\",\"@selected\"],[[28,[37,1],[[30,0],[30,1]],null],[30,0,[\"socialProfileOptions\"]],true,false,[30,0,[\"selectedProfile\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[11,1],[24,0,\"qa--mediaLib_profileSelect\"],[4,[38,2],[[30,0,[\"buildSocialProfileOptions\"]]],null],[4,[38,3],null,null],[12],[1,\"\\n      \"],[10,\"i\"],[15,0,[29,[[30,2,[\"profileIconColorClass\"]],\" u--m__r__xs\"]]],[12],[13],[1,\"\\n      \"],[10,1],[14,\"data-test-id\",\"social-profile-option\"],[12],[1,\"\\n        \"],[1,[30,2,[\"displayNickname\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[2]]]]],[1,\"\\n\"],[13]],[\"@toggleSocialProfile\",\"profile\"],false,[\"power-select\",\"action\",\"did-update\",\"perfect-scroll\"]]",
    "moduleName": "shared/components/shared/media/filter/filter-profile.hbs",
    "isStrictMode": false
  });

  let FilterProfileComponent = (_class = class FilterProfileComponent extends _component2.default {
    get allSelected() {
      return (0, _utils.isEmpty)(this.args.selectedSocialProfileIds) || this.args.selectedSocialProfileIds[0] == null;
    }

    get selectedProfile() {
      if (this.allSelected) {
        return this.socialProfileOptions[0];
      }

      return this.socialProfileOptions.find(socialProfile => socialProfile.id === String(this.args.selectedSocialProfileIds[0]));
    }

    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "intl", _descriptor, this);

      _initializerDefineProperty(this, "socialProfileOptions", _descriptor2, this);

      this.buildSocialProfileOptions();
    }

    buildSocialProfileOptions() {
      this.socialProfileOptions = [{
        id: null,
        profileIconColorClass: '',
        displayNickname: this.intl.t('media_library.filter.all_profiles')
      }, ...this.args.group.socialProfiles.map(socialProfile => ({
        id: socialProfile.get('id'),
        profileIconColorClass: socialProfile.get('profileIconColorClass'),
        displayNickname: socialProfile.get('displayNickname')
      }))];
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "socialProfileOptions", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = FilterProfileComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FilterProfileComponent);
});